/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Tc_Generic_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Generic timecode input" |
*
* @param {Input_Tc_Generic_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_tc_generic_aria_label = /** @type {((inputs?: Input_Tc_Generic_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Tc_Generic_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisie de timecode générique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Generischer Timecode-Eingang")
	if (locale === "it") return /** @type {LocalizedString} */ ("Input di timecode generico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Универсальный ввод временного кода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Entrada de código de tiempo genérico")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("通用时间码输入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("汎用タイムコード入力")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सामान्य समयकोड इनपुट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Entrada de código de tempo genérico")
	return /** @type {LocalizedString} */ ("Generic timecode input")
});